import {
    Component,
    Inject,
    Optional,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatDrawer } from '@angular/material/sidenav';
import { TipoOperacionService} from '../../../services/tipo-operacion.service';
import { UsersService } from 'app/main/services/users.service';
import {Cliente} from '../../../models/cliente.model';
import {ClientesService} from '../../../services/clientes.service';
import {SujetoObligado} from '../../../models/sujeto-obligado.model';


@Component({
  selector: 'filtros-dd',
  templateUrl: './filtros.component.html',
  styleUrls: ['./filtros.component.scss'],
  providers:[DatePipe]
})

export class FiltrosDebidaDiligenciaComponent implements OnInit, OnChanges{


  @Input() filtro: FormGroup;
  @Input() sujetoObligado: SujetoObligado;
  @Output("loadData") loadData: EventEmitter<any> = new EventEmitter();
  @Output() filterChange = new EventEmitter<FormGroup>();


  estados: string[] = ['INICIADO','COMPLETADO','CERRADO'];
  clientes: Cliente[] = [];
  tiposOperacion: any[] = [];
  usuarios: any[] = [];

  hoy: Date = new Date();
  fecha: FormControl = new FormControl((new Date()).toISOString());

  @ViewChild('drawer') sidenav: MatDrawer;

  constructor(
    public datepipe: DatePipe,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private serviceCliente: ClientesService,
    private serviceTipoOperacion: TipoOperacionService,
    private userService: UsersService
    ) {
      //console.log(this.tipoUsuario);
    }

  clean():void{
    this.filtro = this._formBuilder.group({
      tipoOperacion: [],
      cliente: [],
      estados: [],
      fechaDesde: [],
      fechaHasta: []
    });
  }

  onSubmit():void{
    this.filterChange.emit(this.filtro);
    this.loadData.emit();
    this.sidenav.close();
  }

  close(reason: string): void {
    this.sidenav.close();
  }

  ngOnInit(): void {

    this.filtro = this._formBuilder.group({
        tipoOperacion: [],
        cliente: [],
        estados: [],
        fechaDesde: [],
        fechaHasta: []
    });

    this.clientes = [];
    this.tiposOperacion = [];

    if(this.sujetoObligado != null) {
        this.serviceCliente.getAllBySujetoObligado(this.sujetoObligado.id, 0, 1000).pipe().subscribe(req => {
            this.clientes = req.body.map(tipo => {
                console.log(tipo);
                return {
                    id: tipo.id,
                    nombre: tipo.nombre,
                    apellido: tipo.apellido,
                    nombreCompleto: tipo.nombreCompleto,
                };
            });
        });

        this.serviceTipoOperacion.getAllByTipoSujetoObligado(this.sujetoObligado.tipoSujetoObligado.id, 0, 1000).pipe().subscribe(req => {
            req.body.map(tipoOperacion => {

                let tipo = {
                    id: tipoOperacion.id,
                    nombre: tipoOperacion.nombre
                };
                this.tiposOperacion.push(tipo);
            });
        });
    }
  }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.sujetoObligado) {
            this.ngOnInit();
        }
    }

  }
